import { render } from "./NewLoanCalculatorResultMobile.vue?vue&type=template&id=c542816c"
import script from "./NewLoanCalculatorResultMobile.vue?vue&type=script&lang=js"
export * from "./NewLoanCalculatorResultMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__